<div class="video-capture-dialog">
  <div class="close">
    <lib-button icon="close" color="none" (click)="close()"></lib-button>
  </div>
  <video #videoEl [src]="videoUrl" controls preload="metadata" class="video-player"></video>
  <canvas #canvasEl style="display:none"></canvas>
  <div class="extraction-progress" *ngIf="extractionProgress">
    <span>Extraction: {{ extractionProgress.current }} / {{ extractionProgress.total }}</span>
    <mat-progress-bar mode="determinate"
      [value]="(extractionProgress.current / extractionProgress.total) * 100">
    </mat-progress-bar>
  </div>
  <div class="actions">
    <app-spinner *ngIf="isUploading" [diameter]="18" [text]="'form.uploading' | translate"></app-spinner>
    <lib-button icon="photo_camera" color="primary" text="Capturer" (click)="capture()" [disabled]="isAutoExtracting || isUploading"></lib-button>
    <lib-button
      [icon]="isAutoExtracting ? 'stop_circle' : 'motion_photos_auto'"
      [color]="isAutoExtracting ? 'danger' : 'primary'"
      [text]="isAutoExtracting ? 'Arrêter' : 'Auto 5s'"
      [disabled]="isUploading || autoDone"
      (click)="toggleAutoExtract()">
    </lib-button>
  </div>
</div>
